// 14/06/2026 — Bonus fratrie Lumery (validé par l'utilisateur) : quand les
// deux frères sont embauchés ET affectés au même dépôt, leur accumulation
// de fatigue quotidienne baisse de 10 % (ils se relaient, se motivent).
export const LUMERY_BROTHER_IDS = ['philemon-lumery', 'thimothee-lumery'];
export const LUMERY_DUO_FATIGUE_FACTOR = 0.9;
export function lumeryDuoActive(drivers = []) {
  const phil = drivers.find(d => d.dataId === 'philemon-lumery');
  const thim = drivers.find(d => d.dataId === 'thimothee-lumery');
  if (!phil || !thim) return false;
  return (phil.depotId || 'depot-hq') === (thim.depotId || 'depot-hq');
}

export const DRIVERS = [
  // NIVEAU 1 — Débutants
  {
    id: 'karim-belhadj', name: 'Karim Belhadj', level: 1,
    specialty: 'Messagerie/Colis', specialty2: null,
    salaryGross: 1950, employerCost: 2769, experience: 2,
    competence: 2, fatigueMax: 70, accidentRisk: 0.12,
    strength: 'Ponctuel, motivé, apprend vite',
    weakness: "Erreurs d'adresse fréquentes",
    personalityTraits: ['tech-savvy', 'ambitieux'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  {
    id: 'lucie-fontaine', name: 'Lucie Fontaine', level: 1,
    specialty: 'Messagerie/Colis', specialty2: 'Vrac/Palettes',
    salaryGross: 2050, employerCost: 2911, experience: 3,
    competence: 2.5, fatigueMax: 75, accidentRisk: 0.10,
    strength: 'Organisée, bonne relation clients',
    weakness: "Peu à l'aise avec véhicules > 3,5T",
    personalityTraits: ['perfectionniste'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  {
    id: 'dylan-moreaux', name: 'Dylan Moreaux', level: 1,
    specialty: 'Vrac/Palettes', specialty2: null,
    salaryGross: 1900, employerCost: 2698, experience: 1,
    competence: 1.5, fatigueMax: 65, accidentRisk: 0.15,
    strength: 'Fort physiquement, bon chargement',
    weakness: 'Conduite rapide, infractions +20%',
    personalityTraits: ['rebelle', 'fier'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  {
    id: 'amina-toure', name: 'Amina Touré', level: 1,
    specialty: 'Messagerie/Colis', specialty2: null,
    salaryGross: 2000, employerCost: 2840, experience: 2,
    competence: 2, fatigueMax: 72, accidentRisk: 0.11,
    strength: 'Excellente ponctualité, zéro retard',
    weakness: 'Pas de permis C — limité fourgons',
    personalityTraits: ['pragmatique'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  // NIVEAU 2 — Confirmés
  {
    id: 'sebastien-leclerc', name: 'Sébastien Leclerc', level: 2,
    specialty: 'Vrac/Palettes', specialty2: 'BTP/Matériaux/Engins TP',
    salaryGross: 2300, employerCost: 3266, experience: 5,
    competence: 3.5, fatigueMax: 80, accidentRisk: 0.07,
    strength: 'Permis C, habitué aux chantiers BTP',
    weakness: 'Coût élevé pour niveau 2',
    personalityTraits: ['old-school'],
    unlockCondition: 'Porteur Tier 2 actif',
    licenses: ['B', 'C'],
  },
  {
    id: 'nadia-bensalem', name: 'Nadia Bensalem', level: 2,
    specialty: 'Frigo/Pharma', specialty2: 'Messagerie/Colis',
    salaryGross: 2400, employerCost: 3408, experience: 6,
    competence: 3.5, fatigueMax: 78, accidentRisk: 0.06,
    strength: 'Experte chaîne du froid, très fiable',
    weakness: 'Refuse les trajets > 400 km',
    personalityTraits: ['casanier', 'perfectionniste'],
    // 05/02/2026 (Q1 Lot 1) — Retour user : la dépendance « véhicule frigo
    // actif » bloquait Nadia tant qu'on n'avait pas investi dans un frigo,
    // alors qu'elle peut conduire tout porteur Tier 1+ (license C). Désormais
    // disponible dès la phase 1 (cf. fallback driverRecruitment isUnlocked
    // → d.level <= 2).
    unlockCondition: 'Disponible (niveau 2)',
    licenses: ['B', 'C'],
  },
  {
    id: 'thibaut-renard', name: 'Thibaut Renard', level: 2,
    specialty: 'Vrac/Palettes', specialty2: 'Export UE',
    salaryGross: 2250, employerCost: 3195, experience: 4,
    competence: 3, fatigueMax: 82, accidentRisk: 0.08,
    strength: 'Endurance élevée, bon sur axes nationaux',
    weakness: 'Manque de rigueur administrative',
    personalityTraits: ['aventurier'],
    unlockCondition: 'CA > 8 000 €/mois',
    licenses: ['B', 'C'],
  },
  {
    id: 'fatou-diallo', name: 'Fatou Diallo', level: 2,
    specialty: 'Messagerie/Colis', specialty2: 'Export UE',
    salaryGross: 2350, employerCost: 3337, experience: 5,
    competence: 3, fatigueMax: 76, accidentRisk: 0.07,
    strength: 'Multilingue (FR/EN/WO) — atout EU',
    weakness: 'Pas encore de permis CE',
    personalityTraits: ['tech-savvy', 'aventurier'],
    unlockCondition: 'CA > 8 000 €/mois',
    licenses: ['B', 'C'],
  },
  {
    id: 'marco-ferreira', name: 'Marco Ferreira', level: 2,
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Vrac/Palettes',
    salaryGross: 2200, employerCost: 3124, experience: 4,
    competence: 3, fatigueMax: 79, accidentRisk: 0.09,
    strength: "À l'aise avec engins, convois lourds",
    weakness: 'Tensions avec les clients particuliers',
    personalityTraits: ['rebelle', 'introverti'],
    unlockCondition: 'Quai renforcé ou porteur BTP actif',
    licenses: ['B', 'C'],
  },
  // NIVEAU 3 — Expérimentés
  {
    id: 'pierre-yves-gall', name: 'Pierre-Yves Gall', level: 3,
    specialty: 'Export UE', specialty2: 'Vrac/Palettes',
    salaryGross: 2700, employerCost: 3834, experience: 10,
    competence: 4, fatigueMax: 85, accidentRisk: 0.04,
    strength: 'Permis CE, expert semi-remorques',
    weakness: 'Exige planning stable — refuse urgences',
    personalityTraits: ['old-school', 'prudent'],
    unlockCondition: 'Semi-remorque Tier 3',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'isabelle-morin', name: 'Isabelle Morin', level: 3,
    specialty: 'Frigo/Pharma', specialty2: 'Export UE',
    salaryGross: 2800, employerCost: 3976, experience: 9,
    competence: 4.5, fatigueMax: 83, accidentRisk: 0.03,
    strength: 'Spécialiste pharma et agroalim',
    weakness: 'Tarif élevé, négocie sa prime annuelle',
    personalityTraits: ['ambitieux', 'perfectionniste'],
    unlockCondition: 'Semi frigo + CA > 18 000 €/mois',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'rachid-hammami', name: 'Rachid Hammami', level: 3,
    specialty: 'Export UE', specialty2: 'Export UE',
    salaryGross: 2750, employerCost: 3905, experience: 11,
    competence: 4, fatigueMax: 87, accidentRisk: 0.03,
    strength: 'Connaît les axes EU, bilingue FR/AR',
    weakness: 'Absences fréquentes (famille éloignée)',
    personalityTraits: ['aventurier', 'sceptique'],
    unlockCondition: 'Semi Tier 3 + zone EU',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'sylvie-gauthier', name: 'Sylvie Gauthier', level: 3,
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Export UE',
    salaryGross: 2650, employerCost: 3763, experience: 8,
    competence: 4, fatigueMax: 84, accidentRisk: 0.04,
    strength: 'Convois exceptionnels, très disciplinée',
    weakness: 'Ne conduit pas la nuit',
    personalityTraits: ['prudent', 'pragmatique'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  // NIVEAU 4 — Seniors
  {
    id: 'laurent-dubois', name: 'Laurent Dubois', level: 4,
    specialty: 'Export UE', specialty2: 'ADR/Produits sensibles',
    salaryGross: 3200, employerCost: 4544, experience: 18,
    competence: 4.5, fatigueMax: 88, accidentRisk: 0.02,
    strength: 'Permis CE + ADR, aucun incident en 10 ans',
    weakness: 'Cher — salaire fixe incompressible',
    personalityTraits: ['perfectionniste', 'pragmatique'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'miriam-schneider', name: 'Miriam Schneider', level: 4,
    specialty: 'Export UE', specialty2: 'Frigo/Pharma',
    salaryGross: 3400, employerCost: 4828, experience: 15,
    competence: 4.5, fatigueMax: 86, accidentRisk: 0.02,
    strength: 'Trilingue FR/DE/EN — contrats EU premium',
    weakness: 'Refuse les contrats < 2 jours',
    personalityTraits: ['fier', 'ambitieux'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'jerome-castillo', name: 'Jérôme Castillo', level: 4,
    specialty: 'ADR/Produits sensibles', specialty2: 'BTP/Matériaux/Engins TP',
    salaryGross: 3300, employerCost: 4686, experience: 16,
    competence: 4.5, fatigueMax: 89, accidentRisk: 0.01,
    strength: 'Spécialiste citerne chimique, irréprochable',
    weakness: 'Exige véhicule Tier 4+ exclusivement',
    personalityTraits: ['perfectionniste', 'old-school'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'helene-vasseur', name: 'Hélène Vasseur', level: 4,
    specialty: 'Export UE', specialty2: 'Export UE',
    salaryGross: 3100, employerCost: 4402, experience: 14,
    competence: 4.5, fatigueMax: 87, accidentRisk: 0.02,
    strength: 'Rigueur administrative, dossiers parfaits',
    weakness: 'Peu flexible sur les horaires',
    personalityTraits: ['perfectionniste', 'introverti'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  // NIVEAU 5 — Experts
  {
    id: 'alexandre-moreau', name: 'Alexandre Moreau', level: 5,
    specialty: 'Export UE', specialty2: 'ADR/Produits sensibles',
    salaryGross: 4200, employerCost: 5964, experience: 25,
    competence: 5, fatigueMax: 95, accidentRisk: 0.01,
    strength: 'Légende de la route — zéro incident',
    weakness: 'Exige SCANEX R 650 V8 exclusivement',
    personalityTraits: ['fier', 'old-school'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'chantal-perrin', name: 'Chantal Perrin', level: 5,
    specialty: 'Frigo/Pharma', specialty2: 'Export UE',
    salaryGross: 4000, employerCost: 5680, experience: 22,
    competence: 5, fatigueMax: 93, accidentRisk: 0.01,
    strength: 'Référence nationale pharma EU — attire contrats',
    weakness: "Son départ = perte garantie d'un client majeur",
    personalityTraits: ['ambitieux', 'perfectionniste'],
    unlockCondition: 'CA > 50 000 €/mois + véhicule frigo premium',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'youssef-el-amrani', name: 'Youssef El Amrani', level: 5,
    specialty: 'ADR/Produits sensibles', specialty2: 'Export UE',
    salaryGross: 4500, employerCost: 6390, experience: 28,
    competence: 5, fatigueMax: 96, accidentRisk: 0,
    strength: 'Le meilleur ADR de France — bonus contrats x1.3',
    weakness: 'Salaire le plus élevé du jeu',
    personalityTraits: ['fier', 'perfectionniste'],
    unlockCondition: 'Vivier chasseur de tête + 7 mois d\'exercice',
    unlockVia: 'headhunter', minDays: 210,
    licenses: ['B', 'C', 'CE'],
  },
  // 14/06/2026 — Les frères Lumery, duo de chauffeurs d'élite (demande
  // utilisateur). Pleins de qualités : compétence max, fatigue très élevée,
  // risque d'accident nul, double spécialité chacun.
  {
    id: 'philemon-lumery', name: 'Philemon Lumery', level: 5,
    specialty: 'Export UE', specialty2: 'Export UE',
    salaryGross: 4300, employerCost: 6106, experience: 24,
    competence: 5, fatigueMax: 97, accidentRisk: 0,
    strength: 'Aîné des frères Lumery — endurance hors norme, zéro accident en 24 ans',
    weakness: 'N\'accepte de rouler qu\'avec du matériel impeccablement entretenu',
    personalityTraits: ['perfectionniste', 'pragmatique'],
    unlockCondition: 'Vivier chasseur de tête (Karim Sefrioui)',
    unlockVia: 'headhunter',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'thimothee-lumery', name: 'Thimothée Lumery', level: 5,
    specialty: 'Frigo/Pharma', specialty2: 'Messagerie/Colis',
    salaryGross: 4100, employerCost: 5822, experience: 17,
    competence: 5, fatigueMax: 95, accidentRisk: 0,
    strength: 'Cadet des frères Lumery — précision chirurgicale, clients conquis à chaque livraison',
    weakness: 'Veut être affecté au même dépôt que son frère Philemon',
    personalityTraits: ['ambitieux', 'tech-savvy'],
    unlockCondition: 'Vivier chasseur de tête (Karim Sefrioui)',
    unlockVia: 'headhunter',
    licenses: ['B', 'C', 'CE'],
  },

  // ====================================================================
  // RH POOL TIER 1 — débloqués par l'embauche de Nadia Cheikh (RH)
  // 4 profils variés (level 1-3) qui élargissent les options de recrutement
  // ====================================================================
  {
    id: 'eva-laurent', name: 'Eva Laurent', level: 1,
    specialty: 'Messagerie/Colis', specialty2: null,
    salaryGross: 2100, employerCost: 2983, experience: 2,
    competence: 2.5, fatigueMax: 80, accidentRisk: 0.09,
    strength: 'Excellente avec les outils digitaux et le suivi GPS',
    weakness: 'Manque encore d\'expérience longue distance',
    personalityTraits: ['tech-savvy', 'pragmatique'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B'],
  },
  {
    id: 'mohamed-ait-ali', name: 'Mohamed Aït Ali', level: 2,
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Vrac/Palettes',
    salaryGross: 2350, employerCost: 3338, experience: 5,
    competence: 3.2, fatigueMax: 80, accidentRisk: 0.10,
    strength: 'Très polyvalent, à l\'aise sur chantiers',
    weakness: 'Rechigne sur les courses très courtes',
    personalityTraits: ['ambitieux', 'aventurier'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B', 'C'],
  },
  {
    id: 'camille-roux', name: 'Camille Roux', level: 2,
    specialty: 'Frigo/Pharma', specialty2: null,
    salaryGross: 2250, employerCost: 3196, experience: 4,
    competence: 3.0, fatigueMax: 75, accidentRisk: 0.09,
    strength: 'Chaîne du froid maîtrisée, calme sous pression',
    weakness: 'Pas de permis CE',
    personalityTraits: ['pragmatique', 'perfectionniste'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B', 'C'],
  },
  {
    id: 'jean-baptiste-rey', name: 'Jean-Baptiste Rey', level: 3,
    specialty: 'Export UE', specialty2: 'Export UE',
    salaryGross: 2750, employerCost: 3906, experience: 12,
    competence: 3.5, fatigueMax: 85, accidentRisk: 0.08,
    strength: 'Vétéran calme, connaît tous les axes',
    weakness: 'Salaire élevé pour son niveau',
    personalityTraits: ['pragmatique', 'old-school'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B', 'C', 'CE'],
  },

  // ====================================================================
  // RH POOL TIER 2 — débloqués par l'embauche de Karim Sefrioui (Chasseur de tête)
  // 4 profils premium (level 3-5) — talents rares, salaires plus élevés
  // ====================================================================
  {
    id: 'aurelie-bernard', name: 'Aurélie Bernard', level: 3,
    specialty: 'Spécialisé', specialty2: 'Messagerie/Colis',
    salaryGross: 2950, employerCost: 4189, experience: 11,
    competence: 3.7, fatigueMax: 80, accidentRisk: 0.06,
    strength: 'Précision chirurgicale sur les missions sensibles',
    weakness: 'Refuse les missions urgentes mal préparées',
    personalityTraits: ['perfectionniste', 'introverti'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'hassan-el-khoury', name: 'Hassan El Khoury', level: 4,
    specialty: 'ADR/Produits sensibles', specialty2: 'Export UE',
    salaryGross: 3850, employerCost: 5467, experience: 18,
    competence: 4.2, fatigueMax: 85, accidentRisk: 0.05,
    strength: 'Référence pharma/ADR EU — attire des contrats premium',
    weakness: 'Salaire premium, exige Tier 4+',
    personalityTraits: ['ambitieux', 'fier'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'lucia-santos', name: 'Lúcia Santos', level: 4,
    specialty: 'Frigo/Pharma', specialty2: 'Spécialisé',
    salaryGross: 3650, employerCost: 5183, experience: 16,
    competence: 4.0, fatigueMax: 80, accidentRisk: 0.06,
    strength: 'Experte chaîne du froid pharma, irréprochable',
    weakness: 'Cher, exige véhicule premium entretenu',
    personalityTraits: ['perfectionniste', 'ambitieux'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'tom-marchand', name: 'Tom Marchand', level: 5,
    specialty: 'Export UE', specialty2: 'Export UE',
    salaryGross: 4350, employerCost: 6177, experience: 22,
    competence: 4.5, fatigueMax: 90, accidentRisk: 0.04,
    strength: 'Trilingue FR/EN/DE — contrats EU prestige',
    weakness: 'Refuse les contrats < 3 jours',
    personalityTraits: ['aventurier', 'ambitieux'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },

  // ───────────────────────────────────────────────────────────────────────
  // Phase R1 (04/02/2026) — Profils marché ajoutés au vivier dynamique.
  // 14 noms fournis par l'utilisateur + distribution proportionnelle N1-N5.
  // `archetype: 'market'` les distingue des 30 héros (`archetype: 'hero'`
  // implicite) pour la rotation du vivier (driverPoolSlice.js).
  // ───────────────────────────────────────────────────────────────────────
  // N1 (2)
  {
    id: 'marina-roby', name: 'Marina Roby', level: 1, archetype: 'market',
    specialty: 'Messagerie/Colis', specialty2: null,
    salaryGross: 1900, employerCost: 2698, experience: 1,
    competence: 2.4, fatigueMax: 75, accidentRisk: 0.08,
    strength: 'Très ponctuelle, motivée par l\'évolution',
    weakness: 'Hésitante en zone urbaine dense',
    personalityTraits: ['ambitieux', 'prudent'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  {
    id: 'audrey-loisumeau', name: 'Audrey Loisumeau', level: 1, archetype: 'market',
    specialty: 'Messagerie/Colis', specialty2: null,
    salaryGross: 1880, employerCost: 2670, experience: 2,
    competence: 2.6, fatigueMax: 70, accidentRisk: 0.09,
    strength: 'Bon contact client, soigneuse',
    weakness: 'Refuse les trajets > 250 km',
    personalityTraits: ['casanier', 'perfectionniste'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  // N2 (2)
  {
    id: 'samantha-gagne', name: 'Samantha Gagne', level: 2, archetype: 'market',
    specialty: 'Vrac/Palettes', specialty2: 'Messagerie/Colis',
    salaryGross: 2150, employerCost: 3053, experience: 4,
    competence: 2.9, fatigueMax: 78, accidentRisk: 0.07,
    strength: 'Solide en distribution multi-points',
    weakness: 'Tendue avec les chargeurs pressés',
    personalityTraits: ['pragmatique', 'introverti'],
    unlockCondition: 'Départ',
    licenses: ['B', 'C'],
  },
  {
    id: 'antoine-lomy', name: 'Antoine Lomy', level: 2, archetype: 'market',
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Vrac/Palettes',
    salaryGross: 2280, employerCost: 3238, experience: 5,
    competence: 3.0, fatigueMax: 82, accidentRisk: 0.07,
    strength: 'À l\'aise sur les chantiers, costaud',
    weakness: 'Faible en administratif',
    personalityTraits: ['rebelle', 'aventurier'],
    unlockCondition: 'Départ',
    licenses: ['B', 'C'],
  },
  // N3 (3)
  {
    id: 'bruno-vazo', name: 'Bruno Vazo', level: 3, archetype: 'market',
    specialty: 'Export UE', specialty2: 'Vrac/Palettes',
    salaryGross: 2520, employerCost: 3578, experience: 8,
    competence: 3.4, fatigueMax: 85, accidentRisk: 0.06,
    strength: 'Bonne maîtrise des routes UE',
    weakness: 'Réticent aux nouveautés tech',
    personalityTraits: ['old-school', 'pragmatique'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'guillaume-gerve', name: 'Guillaume Gervé', level: 3, archetype: 'market',
    specialty: 'Frigo/Pharma', specialty2: 'Vrac/Palettes',
    salaryGross: 2580, employerCost: 3664, experience: 9,
    competence: 3.5, fatigueMax: 80, accidentRisk: 0.06,
    strength: 'Cold chain maîtrisée, fiable',
    weakness: 'Refuse les changements de planning',
    personalityTraits: ['perfectionniste', 'casanier'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'romuald-tribord', name: 'Romuald Tribord', level: 3, archetype: 'market',
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Export UE',
    salaryGross: 2620, employerCost: 3720, experience: 10,
    competence: 3.6, fatigueMax: 85, accidentRisk: 0.06,
    strength: 'Endurant, à l\'aise en convois lourds',
    weakness: 'Brusque avec les nouveaux collègues',
    personalityTraits: ['rebelle', 'mercenaire'],
    unlockCondition: 'rh-tier-1',
    licenses: ['B', 'C', 'CE'],
  },
  // N4 (4)
  {
    id: 'charly-lenestier', name: 'Charly Lenestier', level: 4, archetype: 'market',
    specialty: 'Export UE', specialty2: 'ADR/Produits sensibles',
    salaryGross: 3050, employerCost: 4331, experience: 14,
    competence: 4.0, fatigueMax: 88, accidentRisk: 0.05,
    strength: 'Habitué aux longs ferries UE',
    weakness: 'Vit pour le métier, salaire ambitieux',
    personalityTraits: ['ambitieux', 'aventurier'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'arnaud-ramette', name: 'Arnaud Ramette', level: 4, archetype: 'market',
    specialty: 'Frigo/Pharma', specialty2: 'Export UE',
    salaryGross: 3100, employerCost: 4402, experience: 15,
    competence: 4.1, fatigueMax: 86, accidentRisk: 0.05,
    strength: 'Précision pharma & agroalim premium',
    weakness: 'Pointilleux sur l\'état du véhicule',
    personalityTraits: ['perfectionniste', 'sceptique'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'isabelle-marmex', name: 'Isabelle Marmex', level: 4, archetype: 'market',
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Vrac/Palettes',
    salaryGross: 3020, employerCost: 4289, experience: 14,
    competence: 3.9, fatigueMax: 87, accidentRisk: 0.05,
    strength: 'Star en transport BTP lourd',
    weakness: 'Refuse les trajets sans nuit à domicile',
    personalityTraits: ['casanier', 'loyal'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  // 09/02/2026 — Q2 Lot F user prod : Sherazade Fetitou retirée du pool
  // chauffeurs et repositionnée comme Responsable Marketing (cf.
  // supportRoles.js role-sherazade-fetitou, remplace Camille Roussel).
  //
  // ─────────────────────────────────────────────────────────────────────
  // 09/02/2026 — Q2 Lot F user prod : profils marché supplémentaires
  // pour enrichir le vivier et rendre les démarrages de partie plus
  // variés (chaque nouvelle partie tire 6 héros aléatoires + ces market
  // drivers entrent/sortent via tickDriverPool). Noms fournis par user.
  // Tous archetype: 'market' → rotation dynamique du vivier.
  {
    id: 'guillaume-monchilong', name: 'Guillaume Monchilong', level: 2, archetype: 'market',
    specialty: 'Vrac/Palettes', specialty2: 'Messagerie/Colis',
    salaryGross: 2280, employerCost: 3238, experience: 4,
    competence: 3, fatigueMax: 80, accidentRisk: 0.07,
    strength: 'Bon profil polyvalent régional',
    weakness: 'Peu d\'expérience longue distance',
    personalityTraits: ['tech-savvy', 'pragmatique'],
    unlockCondition: 'CA > 8 000 €/mois',
    licenses: ['B', 'C'],
  },
  {
    id: 'barbara-rodde', name: 'Barbara Rodde', level: 2, archetype: 'market',
    specialty: 'Frigo/Pharma', specialty2: 'Messagerie/Colis',
    salaryGross: 2350, employerCost: 3337, experience: 5,
    competence: 3.5, fatigueMax: 79, accidentRisk: 0.05,
    strength: 'Méthodique, ZÉRO incident en 5 ans',
    weakness: 'Refuse les heures supplémentaires',
    personalityTraits: ['perfectionniste', 'casanier'],
    unlockCondition: 'CA > 8 000 €/mois',
    licenses: ['B', 'C'],
  },
  {
    id: 'olivia-lollivet', name: 'Olivia Lollivet', level: 1, archetype: 'market',
    specialty: 'Messagerie/Colis', specialty2: 'Vrac/Palettes',
    salaryGross: 1980, employerCost: 2812, experience: 2,
    competence: 2.5, fatigueMax: 78, accidentRisk: 0.08,
    strength: 'Jeune & motivée, marge de progression',
    weakness: 'Stress en zone urbaine dense',
    personalityTraits: ['ambitieux', 'tech-savvy'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  {
    id: 'audrey-tarlu', name: 'Audrey Tarlu', level: 2, archetype: 'market',
    specialty: 'Vrac/Palettes', specialty2: 'Export UE',
    salaryGross: 2290, employerCost: 3252, experience: 5,
    competence: 3, fatigueMax: 84, accidentRisk: 0.06,
    strength: 'Endurance solide, à l\'aise sur autoroute',
    weakness: 'Manque de finesse en manœuvres serrées',
    personalityTraits: ['aventurier', 'pragmatique'],
    unlockCondition: 'Départ',
    licenses: ['B', 'C'],
  },
  {
    id: 'gregoire-khun', name: 'Grégoire Khun', level: 3, archetype: 'market',
    specialty: 'Export UE', specialty2: 'Vrac/Palettes',
    salaryGross: 2680, employerCost: 3806, experience: 9,
    competence: 4, fatigueMax: 86, accidentRisk: 0.04,
    strength: 'Bilingue FR/DE, expert axes Allemagne',
    weakness: 'Difficile à motiver sur trajets nationaux',
    personalityTraits: ['old-school', 'mercenaire'],
    unlockCondition: 'Semi-remorque Tier 3',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'aubin-desbois', name: 'Aubin Desbois', level: 2, archetype: 'market',
    specialty: 'BTP/Matériaux/Engins TP', specialty2: 'Vrac/Palettes',
    salaryGross: 2250, employerCost: 3195, experience: 5,
    competence: 3, fatigueMax: 82, accidentRisk: 0.08,
    strength: 'Spécialiste chantiers boueux & off-road',
    weakness: 'Refuse les zones piétonnes (anxiété)',
    personalityTraits: ['rebelle', 'aventurier'],
    unlockCondition: 'Quai renforcé ou porteur BTP actif',
    licenses: ['B', 'C'],
  },
  {
    id: 'antoni-pauchoir', name: 'Antoni Pauchoir', level: 2, archetype: 'market',
    specialty: 'Messagerie/Colis', specialty2: 'BTP/Matériaux/Engins TP',
    salaryGross: 2200, employerCost: 3124, experience: 4,
    competence: 3, fatigueMax: 80, accidentRisk: 0.07,
    strength: 'Jumeau d\'Anatole — bonus moral si embauchés ensemble',
    weakness: 'Refuse d\'être séparé d\'Anatole > 30 j',
    personalityTraits: ['loyal', 'pragmatique'],
    unlockCondition: 'CA > 8 000 €/mois',
    licenses: ['B', 'C'],
  },
  {
    id: 'anatole-pauchoir', name: 'Anatole Pauchoir', level: 2, archetype: 'market',
    specialty: 'Vrac/Palettes', specialty2: 'BTP/Matériaux/Engins TP',
    salaryGross: 2200, employerCost: 3124, experience: 4,
    competence: 3, fatigueMax: 81, accidentRisk: 0.07,
    strength: 'Jumeau d\'Antoni — bonus moral si embauchés ensemble',
    weakness: 'Refuse d\'être séparé d\'Antoni > 30 j',
    personalityTraits: ['loyal', 'pragmatique'],
    unlockCondition: 'CA > 8 000 €/mois',
    licenses: ['B', 'C'],
  },
  {
    id: 'amaury-dubois', name: 'Amaury Dubois', level: 1, archetype: 'market',
    specialty: 'Messagerie/Colis', specialty2: 'Vrac/Palettes',
    salaryGross: 1950, employerCost: 2769, experience: 1,
    competence: 2.5, fatigueMax: 77, accidentRisk: 0.09,
    strength: 'Apprentissage rapide, polyvalent',
    weakness: 'Encore vert sur conduite défensive',
    personalityTraits: ['ambitieux', 'tech-savvy'],
    unlockCondition: 'Départ',
    licenses: ['B'],
  },
  {
    id: 'clement-dubeck', name: 'Clément Dubeck', level: 3, archetype: 'market',
    specialty: 'Vrac/Palettes', specialty2: 'Frigo/Pharma',
    salaryGross: 2750, employerCost: 3906, experience: 10,
    competence: 4, fatigueMax: 87, accidentRisk: 0.04,
    strength: 'Profil bilingue FR/NL — atout Benelux',
    weakness: 'Refuse les trajets ADR (peur des matières)',
    personalityTraits: ['perfectionniste', 'casanier'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  // N5 (3)
  {
    id: 'willy-wecio', name: 'Willy Wecio', level: 5, archetype: 'market',
    specialty: 'Export UE', specialty2: 'Vrac/Palettes',
    salaryGross: 4100, employerCost: 5822, experience: 21,
    competence: 4.5, fatigueMax: 91, accidentRisk: 0.04,
    strength: 'Référence du marché — attire les contrats',
    weakness: 'Salaire premium, mercenaire',
    personalityTraits: ['mercenaire', 'ambitieux'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'raian-saaady', name: 'Raîan Saaady', level: 5, archetype: 'market',
    specialty: 'ADR/Produits sensibles', specialty2: 'Export UE',
    salaryGross: 4250, employerCost: 6035, experience: 23,
    competence: 4.6, fatigueMax: 92, accidentRisk: 0.03,
    strength: 'Zéro incident en 20 ans ADR / matières dangereuses',
    weakness: 'Inflexible sur les protocoles sécurité',
    personalityTraits: ['perfectionniste', 'prudent'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
  },
  {
    id: 'noemie-lumery', name: 'Noémie Lumery', level: 5, archetype: 'market',
    specialty: 'Frigo/Pharma', specialty2: 'Export UE',
    salaryGross: 4400, employerCost: 6248, experience: 24,
    competence: 4.7, fatigueMax: 90, accidentRisk: 0.03,
    strength: 'Sœur Lumery — précision pharma & cold chain',
    weakness: 'Exige rejoindre le même dépôt que ses frères',
    personalityTraits: ['perfectionniste', 'loyal'],
    unlockCondition: 'rh-tier-2',
    licenses: ['B', 'C', 'CE'],
    unlockVia: 'headhunter', // appartient au vivier élite Karim Sefrioui
  },
];

// ─────────────────────────────────────────────────────────────────────────
// Phase R1 — Helpers pour le vivier dynamique (driverPoolSlice.js).
// ─────────────────────────────────────────────────────────────────────────

/** Tous les chauffeurs (héros + profils marché). */
export const ALL_DRIVERS = DRIVERS;

/** Profils « héros » : 30 chauffeurs originaux, présents toujours au vivier. */
export const HERO_DRIVERS = DRIVERS.filter(d => d.archetype !== 'market');

/** Profils « marché » : ajoutés/retirés dynamiquement du vivier. */
export const MARKET_DRIVERS = DRIVERS.filter(d => d.archetype === 'market');

export const getDriverById = (id) => DRIVERS.find(d => d.id === id);
export const getDriversByLevel = (level) => DRIVERS.filter(d => d.level === level);
